import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "nl",
        lng: ["en", "fr", "nl"].includes(navigator.language.substring(0, 2))
            ? navigator.language.substring(0, 2)
            : "nl",
        defaultNS: "translation",
        ns: ["translation"],
        debug: false,
        backend: {
            // eslint-disable-next-line no-undef
            loadPath: "/locales/{{lng}}/{{ns}}.json?v=" + __APP_VERSION__,
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
